var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.isError)?_c('img',{staticClass:"avatar avatar-sm rounded-lg",attrs:{"src":_vm.url,"alt":_vm.label},on:{"error":function($event){_setup.isError = true}}}):_c('b-avatar',{staticClass:"avatar avatar-sm bg-exitos bg-exitos-5 text-exitos font-weight-bold",attrs:{"text":_vm.label,"rounded":"lg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }